/**
 * Rotation logic for Broken Telephone.
 *
 * With N players in chainOrder [A, B, C, D], each player starts one chain.
 * For the chain started by player at index `i`, the player assigned to
 * round `r` is chainOrder[(i + r) % N].
 *
 * Round 0 = initial draw (even → draw).
 * Odd rounds = guess, even rounds = draw.
 * Total rounds = N (each player contributes once per chain).
 */

/**
 * Build the full rotation map.
 * @param {string[]} chainOrder - shuffled array of user IDs
 * @returns {{ [round: number]: { [userId: string]: { chainStarterId: string, stepIndex: number, type: 'draw'|'guess' } } }}
 */
export function buildRotation(chainOrder) {
  const n = chainOrder.length;
  const rotation = {};

  for (let round = 0; round < n; round++) {
    rotation[round] = {};

    for (let chainIdx = 0; chainIdx < n; chainIdx++) {
      const chainStarterId = chainOrder[chainIdx];
      const playerIdx = (chainIdx + round) % n;
      const userId = chainOrder[playerIdx];

      rotation[round][userId] = {
        chainStarterId,
        stepIndex: round,
        type: round % 2 === 0 ? 'draw' : 'guess',
      };
    }
  }

  return rotation;
}

/**
 * Get a specific player's assignment for a specific round.
 * @param {string[]} chainOrder
 * @param {number} round
 * @param {string} userId
 * @returns {{ chainStarterId: string, stepIndex: number, type: 'draw'|'guess' } | null}
 */
export function getAssignment(chainOrder, round, userId) {
  const n = chainOrder.length;
  const playerIdx = chainOrder.indexOf(userId);
  if (playerIdx === -1) return null;

  // Which chain is this player working on in this round?
  // player at index playerIdx works on chain at index (playerIdx - round + n) % n
  const chainIdx = ((playerIdx - round) % n + n) % n;
  const chainStarterId = chainOrder[chainIdx];

  return {
    chainStarterId,
    stepIndex: round,
    type: round % 2 === 0 ? 'draw' : 'guess',
  };
}
